import React, { useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { transformBarChartData } from "./chartUtils";
import { Tooltip } from "antd";
import { InfoCircleOutlined, LineChartOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";


interface DualAxisBarChartProps {
    chartsData: any[];
    title: string;
    tooltip: string;
}
type ChartType = "bar" | "line";

const DualAxisBarChart: React.FC<DualAxisBarChartProps> = ({ chartsData, title, tooltip }) => {
    const [chartType, setChartType] = useState<ChartType>("bar");
    const { appColors }: any = useSelector((state: RootState) => state.common);

    const transformedData = transformBarChartData(chartsData, appColors?.appPrimaryColor);
    console.log("transformedData: ", transformedData);
    const hasData = chartsData.some(chart => chart.components && chart.components.some(component => component.values.length > 0));

    const toggleChartType = () => {
        setChartType(chartType === "bar" ? "line" : "bar");
    };

    return (
        <div className="chart-container">
            <div className="chart-header">
                <div>
                    <span>{title}</span>
                    <Tooltip title={tooltip}>
                        <InfoCircleOutlined style={{ marginLeft: "8px" }} />
                    </Tooltip>
                </div>
                <LineChartOutlined onClick={toggleChartType} style={{ marginLeft: "8px", cursor: "pointer" }} />
            </div>
            <div className="chart-body">
                {hasData && transformedData ? (
                    chartType === "bar" ? (
                        <Bar options={transformedData.options} data={transformedData.chartData} />
                    ) : (
                        <Line options={transformedData.options} data={transformedData.chartData} />
                    )
                ) : (
                    <div className="no-data">No Data Available</div>
                )}
            </div>
        </div>
    );
};

export default DualAxisBarChart;
